import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CommercialHeader from "@/components/commercial/CommercialHeader";
import { api, fmtEur } from "@/lib/commercialApi";
import { Loader2 } from "lucide-react";

export default function ComClients() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/opportunities", { params: { stage: "signe" } }).then((r) => setRows(r.data.opportunities));
  }, []);
  return (
    <div className="min-h-screen bg-brand-paper">
      <CommercialHeader />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8">
        <div className="eyebrow mb-1">Comptes signés</div>
        <h1 className="font-display text-3xl text-brand-ink mb-6">Clients</h1>
        {rows === null ? <Loader2 className="h-4 w-4 animate-spin text-brand-subtle" />
          : rows.length === 0 ? (
          <div className="rounded-lg border border-brand-line bg-white p-10 text-center max-w-xl mx-auto">
            <div className="font-display text-xl text-brand-ink">Aucun client signé</div>
            <p className="mt-2 text-sm text-brand-subtle">
              Les clients apparaîtront ici après la signature d'un contrat sur une opportunité.
            </p>
            <Link to="/commercial/opportunites" className="mt-5 inline-flex items-center h-9 px-4 rounded-md bg-brand-ink text-white text-xs hover:bg-brand-moss">
              Voir les opportunités
            </Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
            {rows.map((o) => (
              <Link key={o.id} to={`/commercial/opportunites/${o.id}`} className="rounded-lg border border-brand-line bg-white p-4 hover:border-brand-ink/25">
                <div className="font-display text-lg text-brand-ink truncate">{o.entreprise_name}</div>
                <div className="text-xs text-brand-subtle mt-1">{o.contact_nom || "—"}</div>
                <div className="mt-3 text-sm font-mono">{fmtEur(o.montant_final || o.montant_estime)}</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
